import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[appFieldsetDisabled]',
  template: `
    <fieldset [class.disable-pointer]="disabled()" [disabled]="disabled()">
      <ng-content></ng-content>
    </fieldset>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['fieldset-disabled.component.scss']
})
export class FieldsetDisabledComponent {
  readonly disabled = input<boolean>(undefined, {
    alias: 'appFieldsetDisabled'
  });
}
